import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Badge, Tab, Tabs, Button, Form } from 'react-bootstrap';
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";

import { initAuction } from "../components/contract functions/AuctionCall";
import { getAssetDetails, getAssetBalance, convertNormaltoTokenAmount } from '../components/blockchain functions/BlockchainFunctions';
import GetNFT from '../components/page-components/getNFT';
import { chains, eyeglasses, hats, leftHands, rightHands, getGeneration } from '../components/page-components/metadata';
import { validGameNFT } from "../components/page-components/Random";
import { LoginContext } from "../context/LoginContext";

const ViewNFT = () => {
    const { id } = useParams();
    const history = useHistory()
    const [nftData, setNFTData] = useState({});
    const [canBreed, setCanBreed] = useState("No");
    const [isNFTOwner, setIsNFTOwner] = useState(false);
    const [auctionForm, setAuctionForm] = useState(false);
    const [loginData, setLoginData] = useContext(LoginContext);

    const [chain, setChain] = useState("-");
    const [eyeglass, setEyeglass] = useState("-");
    const [hat, setHat] = useState("-");
    const [lefthand, setLefthand] = useState("-");
    const [righthand, setRighthand] = useState("-");
    const [bgColor, setBgColor] = useState("");

    useEffect(async () => {
        let NFTData = await getAssetDetails(id);
        setNFTData(NFTData);
        console.log(NFTData);
    }, []);

    const getAttribute = (name) => {
        var hatId = parseInt(name.slice(6, 7));
        var eyeglassId = parseInt(name.slice(7, 8));
        var chainId = parseInt(name.slice(8, 9));
        var lefthandId = parseInt(name.slice(9, 11));
        var righthandId = parseInt(name.slice(11, 13));

        //Set Images
        if (chains[chainId] !== undefined)
            setChain(chains[chainId]);
        if (eyeglasses[eyeglassId] !== undefined)
            setEyeglass(eyeglasses[eyeglassId]);
        if (hats[hatId] !== undefined)
            setHat(hats[hatId]);
        if (leftHands[lefthandId] !== undefined)
            setLefthand(leftHands[lefthandId]);
        if (rightHands[righthandId] !== undefined)
            setRighthand(rightHands[righthandId]);


        //Background Color
        var bg = name.charAt(name.length - 1);
        switch (bg) {
            case 'R': setBgColor("Red");
                break;
            case 'G': setBgColor("Green");
                break;
            case 'B': setBgColor("Blue");
                break;
            case 'Y': setBgColor("Yellow");
                break;
            default: setBgColor("-");
        }
    }

    useEffect(async () => {
        if (nftData.description?.toString() !=undefined &&JSON.parse(nftData.description?.toString()).crossbreeding)
            setCanBreed("Yes");
        if(nftData.name !=undefined)
            getAttribute(nftData.name);
    }, [nftData]);

    useEffect(async () => {
        if (loginData == null) { return; }
        if (loginData.walletAddress != "") {
            let balance = await getAssetBalance(loginData.walletAddress, id);
            if (balance > 0)
                setIsNFTOwner(true);
        }
    }, [loginData?.walletAddress]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        let startPrice = convertNormaltoTokenAmount(event.target.startPrice.value);
        let instantPrice = convertNormaltoTokenAmount(event.target.instantPrice.value);
        let description = event.target.description.value;
        if (startPrice < instantPrice) {
            let result = await initAuction(startPrice, instantPrice, nftData.assetId, description, loginData.phrase);
            if (result) {
                toast.success("Panada added in marketplace");
                window.setInterval(function () {history.push('/my-collection')},4000);
                
            }
        }
    };


    return (
        <>
            <div className="full-screen">
                <Row>
                    <Col sm={6}>
                        <div className="nftData">
                            <GetNFT nftName={nftData.name} />
                        </div>
                    </Col>
                    <Col sm={6}>
                        <div className="nftData">
                            <div className="details">
                                <span className="name">{nftData.name}</span><span className="issueHeight">#{nftData.issueHeight}</span><br />
                                <span className="assetId">{nftData.assetId}</span><br />
                                <hr />
                                <div hidden={auctionForm}>
                                    <Tabs defaultActiveKey="details" id="uncontrolled-tab-example" className="mb-3">
                                        <Tab eventKey="details" title="Details">
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Birth DateTime</span>
                                                <span className="dot"></span>
                                                <span className="text-end">: {(new Date(nftData.issueTimestamp)).toLocaleString()}</span>
                                            </div>
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Production Rate</span>
                                                <span className="dot"></span>
                                                <span className="text-end">: 0.25</span>
                                            </div>
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Can Breed</span>
                                                <span className="dot"></span>
                                                <span className="text-end">: <Badge bg="danger">{canBreed}</Badge></span>
                                            </div>
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Status</span>
                                                <span className="dot"></span>
                                                <span className="text-end">: <Badge bg="success">Active</Badge></span>
                                            </div>
                                        </Tab>
                                        <Tab eventKey="attributes" title="Attributes">
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Chain</span>
                                                <span className="dot"></span>
                                                <span className="text-end text-capitalize">: {chain}</span>
                                            </div>
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Eyeglass</span>
                                                <span className="dot"></span>
                                                <span className="text-end text-capitalize">: {eyeglass}</span>
                                            </div>
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Hat</span>
                                                <span className="dot"></span>
                                                <span className="text-end text-capitalize">: {hat}</span>
                                            </div>
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Lefthand</span>
                                                <span className="dot"></span>
                                                <span className="text-end text-capitalize">: {lefthand}</span>
                                            </div>
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Righthand</span>
                                                <span className="dot"></span>
                                                <span className="text-end text-capitalize">: {righthand}</span>
                                            </div>
                                            <div className="view-nft-details">
                                                <span className="fw-bold text-start">Backgroundcolor</span>
                                                <span className="dot"></span>
                                                <span className="text-end text-capitalize">: {bgColor}</span>
                                            </div>
                                        </Tab>
                                    </Tabs>
                                    <Row>
                                        {isNFTOwner ?
                                            <Button variant="primary" size="lg" style={{ marginTop: "20px" }}
                                                onClick={() => setAuctionForm(true)}>Sell</Button> :
                                            <></>
                                        }
                                    </Row>
                                </div>
                                <div hidden={!auctionForm}>
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group>
                                            <Form.Label>Auction Start Price<span className="red-text">*</span></Form.Label>
                                            <Form.Control type="number" min="0" step="0.05" defaultValue="1" id="startPrice" required />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Instant Buy Price<span className="red-text">*</span></Form.Label>
                                            <Form.Control type="number" min="0" step="0.05" defaultValue="5" id="instantPrice" required />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Auction Desription</Form.Label>
                                            <Form.Control type="text" id="description" placeholder="about your auction" />
                                        </Form.Group>
                                        <br />
                                        <Row>
                                            <div style={{ width: '50%' }} >
                                                <Button variant="secondary" size="lg" style={{ width: '100%' }} onClick={() => setAuctionForm(false)}>Cancel</Button>
                                            </div>
                                            <div style={{ width: '50%' }} >
                                                <Button variant="primary" type="submit" size="lg" style={{ width: '100%' }}>Start</Button>
                                            </div>
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default ViewNFT